module.exports = __webpack_public_path__ + "ff705ca1b25f00d4851c0160fd9c08dc.png";